import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import { getHeaderAccentMain } from 'styles/helpers/getThemeStyles';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

const StyledButton = styled(Button, {
  shouldForwardProp: muiPropForwarding('highlighted')
})(({ theme, highlighted }) => {
  const borderBottomColor = getHeaderAccentMain(theme);

  return {
    '&.MuiButton-root': {
      padding: 0,
      minWidth: 0,
      [theme.breakpoints.up('md')]: {
        padding: '10px 0 7px 0',
        textTransform: 'none',
        borderRadius: 0,
        borderBottom: `2px ${
          highlighted ? borderBottomColor : 'transparent'
        } solid`
      }
    }
  };
});

function AppBarLink({ fullWidth, dataTestId, children, ...rest }) {
  const { highlighted } = rest;
  return (
    <StyledButton
      highlighted={highlighted}
      fullWidth={fullWidth}
      variant="text"
      data-testid={dataTestId}
    >
      {children}
    </StyledButton>
  );
}

AppBarLink.defaultProps = {
  fullWidth: false
};

AppBarLink.propTypes = {
  highlighted: PropTypes.bool,
  fullWidth: PropTypes.bool,
  dataTestId: PropTypes.string,
  children: PropTypes.node
};

export default AppBarLink;
